import React from "react";
import "./style.scss";
import "./hoverCard.scss";

export const HoverCard = ({ title, description, image, file, fileName, extension='pdf', size='md', fileSize }) => {
    const downloadBook = () => {
          const element = document.createElement("a");
          element.href = file;
          element.download = `${fileName}.${extension}`;
          element.click();
      }
  return (
    <div class="card"
    style={{
      backgroundImage: `url(${image})`
    }}>
        <div class="content">
            <h3>{title}</h3>
            <p className="card-content">{description}</p>
            <div class="icons">
            <div>
          <span className="see-more" onClick={downloadBook}>Download ({fileSize})</span>
          {/* <span className="see-more">Learn More</span> */}
        </div>
            </div>
        </div>
</div>
  );
};